import ThemeSwatch from './ThemeSwatch';
import { commitQuickThemeChange } from '../orchestration/commitThemeChange';
import toggleThemeQuickOptionExpansion from '../data/mutators/toggleThemeQuickOptionExpansion';
import getStore from '../data/store/store';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { FocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import { getSupportedThemeIds } from 'owa-theme';
import * as React from 'react';
import { loadAllThemeResources } from 'owa-theme/lib/orchestrators/loadAllThemeResources';

const styles = require('./Theme.scss');

const COLLAPSED_SIZE = 10;

@observer
export default class ThemeQuick extends React.Component<{}, {}> {
    private pinnedTheme: string;

    constructor(props: {}) {
        super(props);
        // Pin the initially selected theme to the front of the list for as long as this control is mounted
        this.pinnedTheme = getUserConfiguration().UserOptions.ThemeStorageId || 'base';
    }

    componentDidMount() {
        toggleThemeQuickOptionExpansion(false);
        loadAllThemeResources();
    }

    render() {
        let isExpanded = getStore().isQuickOptionExpanded;

        let themeIds = getSupportedThemeIds();
        let showExpandCollapse = true;

        // Push the initially saved theme to the front of the list
        let pinnedThemeIndex = themeIds.indexOf(this.pinnedTheme);
        if (pinnedThemeIndex !== -1) {
            // If the theme can't be found, don't pin an empty theme.
            themeIds.splice(pinnedThemeIndex, 1);
            themeIds.unshift(this.pinnedTheme);
        }

        if (themeIds.length <= COLLAPSED_SIZE) {
            showExpandCollapse = false;
        }
        if (!isExpanded) {
            themeIds = themeIds.slice(0, COLLAPSED_SIZE);
        }

        return (
            <div className={styles.quickContainer}>
                <FocusZone className={styles.swatchContainer} role="listbox">
                    {themeIds.map(id => (
                        <ThemeSwatch themeId={id} onClick={this.onThemeClick} key={id} />
                    ))}
                </FocusZone>
                {showExpandCollapse ? (
                    <CommandButton
                        text={isExpanded ? strings.themeCollapseLabel : strings.themeExpandLabel}
                        onClick={this.toggleExpand}
                        className={styles.expandButton}
                    />
                ) : null}
            </div>
        );
    }

    private toggleExpand() {
        toggleThemeQuickOptionExpansion();
    }

    private onThemeClick(themeId: string) {
        commitQuickThemeChange(themeId);
    }
}
